const { TableCell, TableSortLabel } = window.Material;
import { Dispatch } from 'redux';
import { onTableSort } from '../actions/table';
import { TableHeadProps } from './TableHead';
import { ReduxComponentInterface } from 'edocatbase/Global';
import { SortObj, TableHeader } from 'edocatbase/Table';

interface TableCellProps extends TableHeadProps, ReduxComponentInterface {
  header: TableHeader;
  showSort: boolean;
}

const getSortDirection = (sortObj: SortObj, id: string) => {
  if (id === sortObj.key) {
    return sortObj.direction === 'asc' ? 'desc' : 'asc';
  }

  return 'asc';
};

class EdocatTableCell extends React.PureComponent<TableCellProps> {
  onHeaderClick = (event: React.MouseEvent) => {
    event.preventDefault();
    const { actions, tableSortHandler, header, sortObj, tableName } = this.props;
    if (tableSortHandler) return tableSortHandler(header.id, getSortDirection(sortObj, header.id));
    actions.onTableSort(tableName, header.id);
  };

  render() {
    const { header, sortObj, showSort } = this.props;

    return (
      <TableCell
        key={header.id}
        sortDirection={sortObj ? (sortObj.key === header.id ? sortObj.direction : false) : null}
        align={header.align ?? 'left'}
      >
        {header.sortable && showSort ? (
          <TableSortLabel
            active={sortObj.key === header.id}
            direction={sortObj.key === header.id ? sortObj.direction : 'asc'}
            onClick={this.onHeaderClick}
          >
            {header.label}
          </TableSortLabel>
        ) : (
          header.label
        )}
      </TableCell>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: window.redux.bindActionCreators({ onTableSort }, dispatch),
});

export default window.reactRedux.connect(null, mapDispatchToProps)(EdocatTableCell);
